<template>
  <div class="modal">
    <ConfirmYesNoV2 v-if="isDeletModalOpen" @click-no="closeDeleteModal" @click-yes="confirmDeleteModal">
      <template #confirmmodal-nontitle>
        한줄평을 삭제할까요?
      </template>
    </ConfirmYesNoV2>
    <div class="report-modal">
      <!-- 헤더 -->
      <div class="report-modal-header">
        <h1 class="report-modal-headertitle">
          한줄평
        </h1>
        <a class="close-iconwrap cursor" tabindex="0" @click="closeModal">
          <img class="close-iconwrap" src="/media/images/icon/close-black-icon.png" alt="close-black-icon.png" />
        </a>
      </div>
      <div class="reportlist-box">
        <div class="reportlist-modal">
          <div class="album-img-wrap">
            <img class="album-img" :src="musicInfo.albumImg" alt="" />
          </div>
        </div>
        <div class="reportlist-modal">
          <div class="music-infowrap">
            <span class="music-title">{{ musicInfo.musicNm }}</span>
            <span class="music-artist">{{ musicInfo.artist }}</span>
          </div>
        </div>
      </div>
      <!-- 컨텐츠 -->
      <div class="report-modal-contents">
        <!-- 한줄평 읽기 전용-->
        <div class="w_100per" v-if="!isInput">
          <InputBox
            @focus-event="onFocusEvent"
            :status="''"
            :value="content"
            :disabled="!!content"
            :disabledcolor="'disabledwhite'"
            :placeholder="content ? content : '이 노래의 한줄평을 남겨보세요:)'"
            ref="input_report"
          >
            <template v-if="content" #aftercontents>
              <div class="modifty-iconwrap cursor" @click="isOpenModify = !isOpenModify">
                <img
                  class="modifty-icon cursor"
                  src="/media/images/icon/space-setting-icon.png"
                  alt="space-setting-icon.png"
                />
                <ul class="more-list" v-if="isOpenModify">
                  <li>
                    <a tabindex="0" class="more-listitem cursor" @click="onClickInput">
                      <img
                        class="modify-icon"
                        src="/media/images/icon/space-modify-icon.png"
                        alt="space-modify-icon.png"
                      />
                      <span class="more-listitem-text">수정</span>
                    </a>
                  </li>
                  <li>
                    <a tabindex="0" class="more-listitem last cursor" @click="isDeletModalOpen = true">
                      <img class="delete-icon" src="/media/images/icon/delete-icon.png" alt="delete-icon.png" />
                      <span class="more-listitem-text">삭제</span>
                    </a>
                  </li>
                </ul>
              </div>
            </template>
          </InputBox>
        </div>
        <!-- 한줄평 수정 -->
        <div class="w_100per" v-else>
          <TextArea
            :value="content"
            @cancel-btn="onCancelBtn"
            @confirm-btn="onConfirmBtn"
            :yesBtn="isEnroll ? '등록' : '수정'"
          />
        </div>

        <!-- 한줄평 리스트 -->
        <ul class="report-list" v-if="total < 1">
          <li class="no-list">
            <p>아직 작성된 한줄평이 없어요.</p>
            <p>이 노래의 첫 한줄평을 작성해주세요:)</p>
          </li>
        </ul>
        <ul class="report-list" v-else>
          <li class="report-item" v-for="(item, index) in musicCommentList" :key="'comment' + index">
            <div class="report-userinfo">
              <img
                class="report-userprofile"
                src="/media/images/dummy/dummy-userimage.jpeg"
                alt="dummy-userimage.jpeg"
              />
              <span class="report-userprofile-email">{{ item.email }}</span>
            </div>
            <p class="report-contents" v-html="item.content"></p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import InputBox from '../InputBox/InputBox.vue';
import ConfirmYesNoV2 from '../common/ConfirmYesNoV2.vue';
import TextArea from './TextArea.vue';
import VueCookies from 'vue-cookies';
import axios from 'axios';
export default {
  components: {
    InputBox,
    ConfirmYesNoV2,
    TextArea
  },
  emits: ['close-reportmodal'],
  data() {
    return {
      isDeletModalOpen: false,
      isOpenModify: false,
      isInput: false,
      musicCommentList: [],
      musicId: '',
      musicNm: '',
      content: '',
      total: 0,
      limit: 10,
      offset: 0,
      isEnroll: false
    };
  },
  props: {
    musicInfo: Object
  },
  async mounted() {
    this.musicNm = this.musicInfo.musicNm;
    await this.getMusicCommentList();
    await this.getMusicCommentByUser();
  },
  methods: {
    onClickInput() {
      this.$gatag.event('web_music_comment_edit'); // 수정
      this.isInput = true;
    },
    onFocusEvent() {
      if (!this.$refs.input_report.disabled) {
        this.isInput = true;
        this.isEnroll = true;
      }
    },
    onCancelBtn() {
      this.isInput = false;
      this.isOpenModify = false;
    },
    onConfirmBtn(txt) {
      this.content = txt;
      this.isInput = false;
      this.isOpenModify = false;
      if (this.isEnroll) {
        this.insertMusicComment();
      } else {
        this.updateMusicComment();
      }
    },
    confirmDeleteModal() {
      this.isOpenModify = false;
      this.isDeletModalOpen = false;
      this.removeMusicComment();
    },
    closeDeleteModal() {
      this.isOpenModify = false;
      this.isDeletModalOpen = false;
    },
    closeModal() {
      this.$emit('close-reportmodal');
    },

    removeMusicComment() {
      var aToken = VueCookies.get('aToken');
      var headers = { 'X-AUTH-TOKEN': aToken };
      var musicId = this.musicInfo.musicId;
      var userId = VueCookies.get('userId');

      axios
        .post('/api/player/removeMusicComment', { musicId, userId }, { headers })
        .then(res => {
          if (res.data.resultCd === '0000') {
            this.updateComment = false;
            this.content = '';
            this.getMusicCommentList();
            this.$emit('removeComment', musicId);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    updateMusicComment() {
      var aToken = VueCookies.get('aToken');
      var headers = { 'X-AUTH-TOKEN': aToken };
      var musicId = this.musicInfo.musicId;
      var userId = VueCookies.get('userId');
      var content = this.content;

      axios
        .post('/api/player/updateMusicComment', { musicId, userId, content }, { headers })
        .then(res => {
          if (res.data.resultCd === '0000') {
            this.getMusicCommentByUser();
            this.getMusicCommentList();
            this.$emit('updateComment', musicId, content);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    insertMusicComment() {
      const aToken = VueCookies.get('aToken');
      const headers = { 'X-AUTH-TOKEN': aToken };
      const musicId = this.musicInfo.musicId;
      const userId = VueCookies.get('userId');
      const spaceId = this.musicInfo.spaceId;
      const content = this.content;

      axios
        .post('/api/player/insertMusicComment', { musicId, userId, spaceId, content }, { headers })
        .then(res => {
          if (res.data.resultCd === '0000') {
            this.getMusicCommentByUser();
            this.getMusicCommentList();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    async getMusicCommentList() {
      var aToken = VueCookies.get('aToken');
      var headers = { 'X-AUTH-TOKEN': aToken };
      var musicId = this.musicInfo.musicId;
      var limit = this.limit;
      var offset = this.offset;

      await axios
        .post('/api/player/selectMusicCommentListByMusic', { musicId, limit, offset }, { headers })
        .then(res => {
          if (res.data.resultCd === '0000') {
            var result = res.data.result;
            this.musicCommentList = result.musicCommentList;
            this.total = result.totalCount;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    async getMusicCommentByUser() {
      var aToken = VueCookies.get('aToken');
      var headers = { 'X-AUTH-TOKEN': aToken };
      var musicId = this.musicInfo.musicId;
      var userId = VueCookies.get('userId');

      await axios
        .post('/api/player/selectMusicCommentByUser', { musicId, userId }, { headers })
        .then(res => {
          if (res.data.resultCd === '0000') {
            var result = res.data.result;
            this.musicId = result.musicId;
            this.content = result.content;
            result === null ? (this.updateComment = false) : (this.updateComment = true);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    baseurl() {
      return process.env.VUE_APP_BASE_URL;
    }
  }
};
</script>
<style scoped src="@/assets/css/reportmodal/reportmodal.css"></style>
